import { render, staticRenderFns } from "./SourceEditor.vue?vue&type=template&id=5c2863fb&"
import script from "./SourceEditor.vue?vue&type=script&lang=js&"
export * from "./SourceEditor.vue?vue&type=script&lang=js&"
import style0 from "./SourceEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports